import * as React from 'react'
import Recaptcha from 'react-recaptcha';
import * as classNames from 'classnames/bind';
import { validation } from '../../../utils/validation';
import config from '../../../config/config';
import api from '../../../utils/api';

import SuccessForm from '../SuccessForm/SuccessForm';
import TrackableInput from '../TrackableInput';
import TrackableElement from '../TrackableElement';

import * as styles from './ContactForm.module.scss';

let cx = classNames.bind(styles);

class ContactForm extends React.Component {
  state = {
    subject: '',
    site: '',
    text: '',
    email: '',
    recaptchaResponse: null,
    errors: {},
    isSuccess: false,
    isError: false,
    isDisabledBtn: false
  };

  handleChange = (event, target) => {
    const { errors } = this.state;

    delete errors[target];

    this.setState({
      errors,
      [target]: event.target.value,
      isError: false
    });
  };

  handleRecaptcha = response => {
    const { errors } = this.state;

    delete errors.recaptchaResponse;

    this.setState({ recaptchaResponse: response, errors });
  };

  onFormSubmit = event => {
    event.preventDefault();

    const errors = validation(this.state);

    this.setState({ errors });

    if (!Object.keys(errors).length) {
      this.submit();
    }
  };

  submit = () => {
    const { subject, text, email, site, recaptchaResponse } = this.state;

    let data = {
      subject,
      text,
      email,
      site: subject === 'potential_partner' ? site : '',
      'g-recaptcha-response': recaptchaResponse
    };

    this.setState({ isError: false, isDisabledBtn: true });

    api(`${config.apiURL}/api/feedback`, data)
      .then(() => {
        this.setState({ errors: {}, isSuccess: true, isDisabledBtn: false });
      })
      .catch(error => {
        this.setState({ isError: true, isDisabledBtn: false });
        console.error('submit error', error);
      })
  };

  render() {
    const { subject, text, email, site, errors, isSuccess, isError, isDisabledBtn } = this.state;

    return (
      <>
        {isSuccess ?
          <SuccessForm /> :
          <form className={styles.root} onSubmit={this.onFormSubmit}>
            <section className={styles.container}>
              <span className={styles.text}>My email</span>
              <TrackableInput
                name="email"
                id='email'
                type="text"
                value={email}
                className={cx('input', { error: !!errors.email })}
                placeholder="name@company.com"
                onChange={(event) => this.handleChange(event, 'email')}
                eventCategory="contact_form"
                startEventAction="email_start"
                editEventAction="email_edit"
                finishEventAction="email_finish"
                trackValue={false}
              />
              <div className={styles.errorContainer}>
                {errors.email && <span className={styles.errorMessage}>{errors.email}</span>}
              </div>
            </section>
            <section className={cx('select', { selectCenter: !subject })}>
              <span className={styles.text}>I’d like</span>
              <TrackableElement
                className={cx('input', { error: !!errors.subject })}
                name='subject'
                id='subject'
                value={subject}
                element="select"
                eventCategory="contact_form"
                eventAction="i_want_select"
                eventLabel={event => event.target.value}
                onChange={(event) => this.handleChange(event, 'subject')}
                trackingAction="onChange"
              >
                <option value='' hidden>Select option</option>
                <option value='potential_partner'>to be a partner</option>
                <option value='get_infographics'>to get the infographics</option>
                <option value='other'>other</option>
              </TrackableElement>
              <div className={styles.errorContainer}>
                {errors.subject && <span className={styles.errorMessage}>{errors.subject}</span>}
              </div>
            </section>
            {subject === 'potential_partner' &&
            <section className={styles.container}>
              <span className={styles.text}>Here’s my site</span>
              <TrackableInput
                name="site"
                id='site'
                type="text"
                value={site}
                className={cx('input', { error: !!errors.site })}
                placeholder="www.mysite.com"
                onChange={(event) => this.handleChange(event, 'site')}
                eventCategory="contact_form"
                startEventAction="site_start"
                editEventAction="site_edit"
                finishEventAction="site_finish"
                trackValue={true}
              />
              <div className={styles.errorContainer}>
                {errors.site && <span className={styles.errorMessage}>{errors.site}</span>}
                {site && errors.site &&
                <span className={styles.partnersInfo}>
                   You need to have your ads published on a website if you want to become our partner.{' '}
                  <a href="https://flatfy.in/partnership#become-partner" target="_blank" rel="noopener noreferrer">
                    About partnership
                  </a>
                 </span>
                }
              </div>
            </section>
            }
            <section>
              <span className={styles.fullWidthText}>More specifically,</span>
              <TrackableInput
                name="text"
                id='text'
                type="text"
                value={text}
                className={cx('input', 'textArea', { error: !!errors.text })}
                placeholder="Comment"
                onChange={(event) => this.handleChange(event, 'text')}
                eventCategory="contact_form"
                startEventAction="comment_start"
                editEventAction="comment_edit"
                finishEventAction="comment_finish"
                multiline={true}
                trackValue={false}
              />
              <div className={styles.errorContainer}>
                {errors.text && <span className={styles.errorMessage}>{errors.text}</span>}
              </div>
            </section>
            <div className={cx('recaptchaContainer', { error: !!errors.recaptchaResponse })}>
              <Recaptcha
                sitekey={config.recaptchaPublicKey}
                render="explicit"
                onloadCallback={() => {
                }}
                verifyCallback={this.handleRecaptcha}
              />
            </div>
            {isError &&
            <p className={styles.textError}>Something went wrong. Try again later</p>
            }
            <TrackableElement
              className={styles.submitBtn}
              element="button"
              disabled={isDisabledBtn}
              type='submit'
              eventCategory="contact_form"
              eventAction="send_btn_click"
            >
              Send
            </TrackableElement>
          </form>
        }
      </>
    )
  }
}

export default ContactForm;
